import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterPledgeAgreementPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='pledge_agreement_general'
        title='Pledge Agreement'
        activeTab='pledgeAgreement'
        navConfig={null}
      />
    )
  }
}

export default MasterPledgeAgreementPageSF
